import { connect } from 'react-redux';

import PRODUCT_TYPE from 'Component/Product/Product.config';
import {
    CartItemContainer as SourceCartItemContainer,
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps
} from 'SourceComponent/CartItem/CartItem.container';
import { setCartLoading } from 'Store/Cart/Cart.action';
import componentLoader from 'Util/componentLoader';
import { getMaxQuantity, getMinQuantity, getProductInStock } from 'Util/Product/Extract';

export const CartDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/Cart/Cart.dispatcher'
), 2);

/** @namespace Bodypwa/Component/CartItem/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    isCheckout: state.CheckoutReducer.isCheckout,
    loading: state.CartReducer.loading
    // TODO extend mapStateToProps
});
/** @namespace Bodypwa/Component/CartItem/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    setCartLoading: (loading) => dispatch(setCartLoading(loading)),
    addProduct: (options) => CartDispatcher.then(
        ({ default: dispatcher }) => dispatcher.addProductToCart(dispatch, options)
    )
});
/** @namespace Bodypwa/Component/CartItem/Container */
export class CartItemContainer extends SourceCartItemContainer {
    containerProps = () => {
        const {
            item,
            currency_code,
            isEditing,
            isCartOverlay,
            isMobile,
            showLoader,
            loading
        } = this.props;
        const { isLoading } = this.state;

        return {
            item,
            currency_code,
            isEditing,
            isCartOverlay,
            isMobile,
            isLoading,
            loading,
            showLoader,
            linkTo: this._getProductLinkTo(),
            thumbnail: this._getProductThumbnail(),
            minSaleQuantity: getMinQuantity(this.getCurrentProduct()),
            maxSaleQuantity: getMaxQuantity(this.getCurrentProduct()),
            isProductInStock: this.productIsInStock(),
            optionsLabels: this.getConfigurableOptionsLabels(),
            isMobileLayout: this.getIsMobileLayout()
        };
    };

    getIsMobileLayout() {
        // "isMobileLayout" check is required to render mobile content in some additional cases
        // where screen width exceeds 810px (e.g. CartOverlay)
        const { isMobile, isCartOverlay, isCheckout } = this.props;

        return isMobile || isCartOverlay || isCheckout;
    }

    getConfigurationOptionLabel = ([key, attribute]) => {
        const {
            item: {
                product: {
                    configurable_options = {}
                }
            }
        } = this.props;

        const { attribute_code, attribute_value } = attribute;

        if (!Object.keys(configurable_options).includes(key) || attribute_value === null) {
            return null;
        }

        const {
            [attribute_code]: { // configurable option attribute
                attribute_options: {
                    [attribute_value]: { // attribute option value label
                        label
                    }
                },
                attribute_label
            }
        } = configurable_options;

        const option = `${attribute_label}: ${label}`;

        return option;
    };

    getConfigurableOptionsLabels() {
        const {
            item: {
                product: {
                    configurable_options,
                    variants
                }
            }
        } = this.props;

        if (!variants || !configurable_options) {
            return [];
        }

        const { attributes = [] } = this.getCurrentProduct() || {};

        return Object.entries(attributes)
            .filter(([attrKey]) => Object.keys(configurable_options).includes(attrKey))
            .map(this.getConfigurationOptionLabel)
            .filter((label) => label);
    }

    handleInputChangeQuantity() {
    }

    /**
     * Get link to product page
     * @param url_key Url to product
     * @return {{pathname: String, state Object}} Pathname and product state
     */
    _getProductLinkTo() {
        const {
            item: {
                product,
                product: {
                    type_id,
                    parent,
                    url
                } = {}
            } = {}
        } = this.props;

        if (type_id !== PRODUCT_TYPE.configurable) {
            return {
                pathname: url,
                state: { product: { ...product, attributes: {} } }
            };
        }

        const variant = this.getProductVariant();

        if (!variant) {
            return {};
        }

        const stateProduct = parent || product;

        return {
            pathname: url,
            state: { product: stateProduct },
            search: ''
        };
    }

    /**
     * Handle item quantity change. Check that value is <1
     * @param {Number} value new quantity
     * @return {void}
     */
    handleChangeQuantity(quantity) {
        const {
            changeItemQty, item: { item_id, qty = 1 }, setCartLoading, cartId
        } = this.props;

        setCartLoading(true);
        this.setState({ isLoading: true }, () => {
            if (quantity === qty) {
                this.setState({ isLoading: false });
                return;
            }

            this.hideLoaderAfterPromise(changeItemQty({
                uid: btoa(item_id),
                quantity,
                cartId
            }));
        });
        this.notifyAboutLoadingStateChange(true);
    }

    handleInputBlur(quantity) {
        const { item: { qty = 1 } } = this.props;
        this.setState({ isLoading: true }, () => {
            const {
                changeItemQty, setCartLoading, item: { item_id, qty = 1 }, cartId
            } = this.props;
            const parsedQty = parseInt(quantity, 10);
            if (parsedQty === qty) {
                this.setState({ isLoading: false });
                return;
            }

            this.hideLoaderAfterPromise(changeItemQty({
                uid: btoa(item_id),
                quantity: parsedQty,
                cartId
            }));
            setCartLoading(true);
        });
        if (qty !== quantity) {
            this.notifyAboutLoadingStateChange(true);
        }
    }

    productIsInStock() {
        const { item: { product } } = this.props;

        return getProductInStock(product, product, true);
    }

    containerFunctions = {
        handleChangeQuantity: this.handleChangeQuantity.bind(this),
        handleInputChangeQuantity: this.handleInputChangeQuantity.bind(this),
        handleInputBlur: this.handleInputBlur.bind(this),
        handleRemoveItem: this.handleRemoveItem.bind(this),
        getCurrentProduct: this.getCurrentProduct.bind(this),
        getProductVariant: this.getProductVariant.bind(this)
    };

    /**
     * @return {void}
     */
    handleRemoveItem(e) {
        setTimeout(() => {
            this.handleRemoveItemOnSwipe(e);
            this.notifyAboutLoadingStateChange(true);
        // eslint-disable-next-line no-magic-numbers
        }, 200);
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CartItemContainer);
